<h2>
    Недавние формы
</h2>
<div class="polls">
    <div class="poll" (click)="createPoll()">
        <div class="create-plus" >
            +
        </div>
        <div class="poll-title">
            Создать новую форму
        </div>
    </div>
    <div class="poll" *ngFor="let poll of polls; let i=index" [routerLink]="['edit', poll.id]">
        <div class="poll-title">
            {{poll.name}}
        </div>
        <div class="delete" (click)="deletePoll(poll.id, i)">
            <mat-icon>delete</mat-icon>
        </div>
    </div>
</div>